import { render, staticRenderFns } from "./list-warranty-paperless.vue?vue&type=template&id=033b15a1&scoped=true&"
import script from "./list-warranty-paperless.vue?vue&type=script&lang=js&"
export * from "./list-warranty-paperless.vue?vue&type=script&lang=js&"
import style0 from "./list-warranty-paperless.vue?vue&type=style&index=0&id=033b15a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b15a1",
  null
  
)

export default component.exports